import React from 'react';
import { Calendar, MapPin, Clock, Laptop, Wifi, Globe, CheckCircle } from 'lucide-react';
export function CourseDetails() {
  return <section className="mb-12" data-id="element-233">
      <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-234">Course Details</h2>

      {/* Course Format */}
      <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 mb-8 border border-blue-100" data-id="element-235">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-236">Course Format</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-237">
          <div className="flex items-start gap-3" data-id="element-238">
            <Clock className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-239" />
            <div data-id="element-240">
              <p className="font-semibold text-gray-900" data-id="element-241">Duration</p>
              <p className="text-gray-700" data-id="element-242">8 weeks</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-243">
            <MapPin className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-244" />
            <div data-id="element-245">
              <p className="font-semibold text-gray-900" data-id="element-246">Location</p>
              <p className="text-gray-700" data-id="element-247">Virtual</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-248">
            <Calendar className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-249" />
            <div data-id="element-250">
              <p className="font-semibold text-gray-900" data-id="element-251">Format</p>
              <p className="text-gray-700" data-id="element-252">Self-paced, cohort-based</p>
            </div>
          </div>
        </div>
      </div>

      {/* Course Requirements */}
      <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-8 mb-8 border border-green-100" data-id="element-253">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-254">
          Course Requirements
        </h3>
        <div className="space-y-4" data-id="element-255">
          <div className="flex items-start gap-3" data-id="element-256">
            <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-257" />
            <p className="text-gray-700" data-id="element-258">
              Commitment to coursework within duration of programme
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-259">
            <Laptop className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-260" />
            <p className="text-gray-700" data-id="element-261">
              Device: PC or laptop recommended (Windows 10+/macOS latest);
              smartphones may be used for some activities
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-262">
            <Wifi className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-263" />
            <p className="text-gray-700" data-id="element-264">
              Reliable internet connection for live sessions
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-265">
            <Globe className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-266" />
            <p className="text-gray-700" data-id="element-267">
              Compatible browsers: latest Google Chrome, Firefox, Edge, or
              Safari
            </p>
          </div>
        </div>
      </div>

      {/* Target Audience */}
      <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100" data-id="element-268">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-269">
          Who Should Enroll?
        </h3>
        <p className="text-gray-700 mb-4" data-id="element-270">This course is perfect for:</p>
        <div className="space-y-3" data-id="element-271">
          <div className="flex items-start gap-3" data-id="element-272">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-273"></div>
            <p className="text-gray-700" data-id="element-274">
              <span className="font-semibold" data-id="element-275">
                Aspiring Executive Assistants
              </span>{' '}
              looking to break into high-level admin and executive support roles
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-276">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-277"></div>
            <p className="text-gray-700" data-id="element-278">
              <span className="font-semibold" data-id="element-279">
                Administrative Professionals & Secretaries
              </span>{' '}
              seeking promotion into more strategic roles
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-280">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-281"></div>
            <p className="text-gray-700" data-id="element-282">
              <span className="font-semibold" data-id="element-283">Personal Assistants</span> ready
              to upskill and earn more
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-284">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-285"></div>
            <p className="text-gray-700" data-id="element-286">
              <span className="font-semibold" data-id="element-287">Office Managers</span>{' '}
              transitioning into EA roles
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-288">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-289"></div>
            <p className="text-gray-700" data-id="element-290">
              <span className="font-semibold" data-id="element-291">Recent graduates</span> targeting
              remote or hybrid EA job roles
            </p>
          </div>
        </div>
      </div>
    </section>;
}